"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAnnouncements = exports.selectAnnouncements = exports.selectAllActiveMOTDsForToday = exports.selectAllMember = exports.selectAllTeam = exports.selectAllMOTDs = exports.createAnnouncement = exports.deleteAnnouncementWithID = exports.updateAccknowledgeForAnnouncementWithID = exports.editBroadcastDateForAnnouncementWithID = exports.updatePinForAnnouncementWithID = exports.announcementStorageConfig = exports.announcementSliceConfig = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var moment_1 = __importDefault(require("moment"));
var firestore_1 = require("firebase/firestore");
var storage_1 = require("firebase/storage");
var uuid_1 = require("uuid");
var common_1 = require("@dayone/common");
var teamSlice_1 = require("./teamSlice");
var firebaseApp;
var firestore;
var storage;
var announcementSliceConfig = function (_firebaseApp) {
    firebaseApp = _firebaseApp;
    firestore = (0, firestore_1.getFirestore)(_firebaseApp);
};
exports.announcementSliceConfig = announcementSliceConfig;
var announcementStorageConfig = function (storageBucketConfig) {
    var announcementStorageBucket = storageBucketConfig.announcement;
    storage = (0, storage_1.getStorage)(firebaseApp, announcementStorageBucket);
};
exports.announcementStorageConfig = announcementStorageConfig;
var initialState = {
    initialised: false,
    announcements: [],
};
var announcementSlice = (0, toolkit_1.createSlice)({
    name: 'task',
    initialState: initialState,
    reducers: {
        setAnnouncements: {
            reducer: function (state, action) {
                if (action.payload) {
                    state.announcements = action.payload;
                    state.initialised = true;
                }
            },
            prepare: function (payload) {
                if (payload) {
                    var announcementModels = payload.map(function (announcement) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        return ({
                            id: announcement.id,
                            announcementID: (announcement === null || announcement === void 0 ? void 0 : announcement.announcementID) || '',
                            message: (announcement === null || announcement === void 0 ? void 0 : announcement.message) || '',
                            companyID: (announcement === null || announcement === void 0 ? void 0 : announcement.companyID) || '',
                            branchID: (announcement === null || announcement === void 0 ? void 0 : announcement.branchID) || '',
                            acknowledged: ((announcement === null || announcement === void 0 ? void 0 : announcement.acknowledged) || []).map(function (acknowledgeUser) {
                                var _a, _b;
                                return ({
                                    uid: acknowledgeUser.uid,
                                    time: acknowledgeUser.time instanceof firestore_1.Timestamp ? (_b = (_a = acknowledgeUser.time) === null || _a === void 0 ? void 0 : _a.toDate().toISOString()) !== null && _b !== void 0 ? _b : '' : '',
                                });
                            }),
                            pin: (announcement === null || announcement === void 0 ? void 0 : announcement.pin) || false,
                            images: announcement.images || [],
                            isScheduled: announcement.isScheduled || false,
                            broadcastDate: announcement.broadcastDate instanceof firestore_1.Timestamp ? (_a = announcement.broadcastDate) === null || _a === void 0 ? void 0 : _a.toDate().toISOString() : '',
                            createdAt: (announcement === null || announcement === void 0 ? void 0 : announcement.createdAt) instanceof firestore_1.Timestamp ? (_c = (_b = announcement.createdAt) === null || _b === void 0 ? void 0 : _b.toDate().toISOString()) !== null && _c !== void 0 ? _c : '' : '',
                            createdBy: (_d = announcement.createdBy) !== null && _d !== void 0 ? _d : '',
                            createdByDisplayName: (_e = announcement.createdByDisplayName) !== null && _e !== void 0 ? _e : '',
                            updatedAt: (announcement === null || announcement === void 0 ? void 0 : announcement.updatedAt) instanceof firestore_1.Timestamp ? (_g = (_f = announcement.updatedAt) === null || _f === void 0 ? void 0 : _f.toDate().toISOString()) !== null && _g !== void 0 ? _g : '' : '',
                            updatedBy: (_h = announcement.updatedBy) !== null && _h !== void 0 ? _h : '',
                            updatedByDisplayName: (_j = announcement.updatedByDisplayName) !== null && _j !== void 0 ? _j : '',
                        });
                    });
                    return { payload: announcementModels };
                }
                return { payload: null };
            },
        },
    },
});
// CRUD
exports.updatePinForAnnouncementWithID = (0, toolkit_1.createAsyncThunk)('announcement/updatePin', function (args, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, uid, displayName, id, pin, baseAnnouncementColRef, announcementDocRef;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                uid = (_b = (_a = state.me.details) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : '';
                displayName = (_c = state.me.account) === null || _c === void 0 ? void 0 : _c.displayName;
                id = args.id, pin = args.pin;
                baseAnnouncementColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'motds');
                announcementDocRef = (0, firestore_1.doc)(baseAnnouncementColRef, id);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(announcementDocRef, {
                        pin: pin,
                        updatedAt: firestore_1.Timestamp.now(),
                        updatedBy: uid,
                        updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                    })];
            case 1:
                _d.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.editBroadcastDateForAnnouncementWithID = (0, toolkit_1.createAsyncThunk)('announcement/editBroadcastDate', function (args, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, uid, displayName, id, broadcastDate, baseAnnouncementColRef, announcementDocRef;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                uid = (_b = (_a = state.me.details) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : '';
                displayName = (_c = state.me.account) === null || _c === void 0 ? void 0 : _c.displayName;
                id = args.id, broadcastDate = args.broadcastDate;
                baseAnnouncementColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'motds');
                announcementDocRef = (0, firestore_1.doc)(baseAnnouncementColRef, id);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(announcementDocRef, {
                        broadcastDate: firestore_1.Timestamp.fromDate((0, moment_1.default)(broadcastDate).toDate()),
                        updatedAt: firestore_1.Timestamp.now(),
                        updatedBy: uid,
                        updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                    })];
            case 1:
                _d.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.updateAccknowledgeForAnnouncementWithID = (0, toolkit_1.createAsyncThunk)('announcement/updateAccknowledge', function (args, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, uid, activeWorkspaceID, id, allAnnouncements, announcementID, userTeamIds, acknowledgedMessageOnAllBranches, baseAnnouncementColRef;
    return __generator(this, function (_a) {
        state = thunkAPI.getState();
        uid = state.me.details.uid;
        activeWorkspaceID = state.setting.activeWorkspaceID;
        id = args.id;
        allAnnouncements = state.announcement.announcements;
        announcementID = (allAnnouncements.find(function (motd) { return motd.id === id; }) || {
            announcementID: '',
        }).announcementID;
        userTeamIds = (0, teamSlice_1.selectCurrentUserTeams)(state).map(function (team) { return team.teamId; });
        acknowledgedMessageOnAllBranches = allAnnouncements.filter(function (motd) { return motd.announcementID === announcementID && userTeamIds.includes(motd.branchID); });
        baseAnnouncementColRef = (0, firestore_1.collection)(firestore, 'companies', activeWorkspaceID, 'motds');
        acknowledgedMessageOnAllBranches.forEach(function (motd) { return __awaiter(void 0, void 0, void 0, function () {
            var announcementDocRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        announcementDocRef = (0, firestore_1.doc)(baseAnnouncementColRef, motd.id);
                        return [4 /*yield*/, (0, firestore_1.updateDoc)(announcementDocRef, {
                                acknowledged: (0, firestore_1.arrayUnion)({
                                    time: firestore_1.Timestamp.fromDate(new Date()),
                                    uid: uid,
                                }),
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/];
    });
}); });
exports.deleteAnnouncementWithID = (0, toolkit_1.createAsyncThunk)('announcement/delete', function (args, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, id, baseAnnouncementColRef, announcementDocRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                id = args.id;
                baseAnnouncementColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'motds');
                announcementDocRef = (0, firestore_1.doc)(baseAnnouncementColRef, id);
                return [4 /*yield*/, (0, firestore_1.deleteDoc)(announcementDocRef)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.createAnnouncement = (0, toolkit_1.createAsyncThunk)('announcement/create', function (args, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, displayName, uid, branches, message, pin, images, isScheduled, broadcastDate, baseAnnouncementColRef, _a, numberOfFileLimit, filesizeLimit, compressedFiles, totalFileSize, uploadMedia, announcementID, documentCreationPromises;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                displayName = (_b = state.me.account) === null || _b === void 0 ? void 0 : _b.displayName;
                uid = state.me.details.uid;
                branches = args.branches, message = args.message, pin = args.pin, images = args.images, isScheduled = args.isScheduled, broadcastDate = args.broadcastDate;
                baseAnnouncementColRef = (0, firestore_1.collection)(firestore, 'companies', companyID, 'motds');
                if (!images) return [3 /*break*/, 2];
                _a = state.featureFlag.featureFlags.announcement, numberOfFileLimit = _a.numberOfFileLimit, filesizeLimit = _a.filesizeLimit;
                if (numberOfFileLimit < images.length)
                    throw new Error('You have reached your number of files limit');
                return [4 /*yield*/, Promise.all(images.filter(function (item) { return !!item.file; }).map(function (item) { return common_1.ImageHelper.default.transformFileSize(item.file); }))];
            case 1:
                compressedFiles = _c.sent();
                totalFileSize = compressedFiles.reduce(function (total, file) { return total + (file.size || 0); }, 0) / 1048576;
                if (filesizeLimit < totalFileSize)
                    throw new Error('You have reached your file size limit');
                _c.label = 2;
            case 2:
                uploadMedia = function (file, announcementID) { return __awaiter(void 0, void 0, void 0, function () {
                    var compressedFile, uuidName, ext, baseStorageRef, uploadTask, url, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!file) return [3 /*break*/, 4];
                                return [4 /*yield*/, common_1.ImageHelper.default.transformFileSize(file)];
                            case 1:
                                compressedFile = _a.sent();
                                uuidName = (0, uuid_1.v4)();
                                ext = compressedFile.name.slice(compressedFile.name.lastIndexOf('.'));
                                baseStorageRef = (0, storage_1.ref)(storage, "/".concat(companyID, "/").concat(announcementID, "/").concat(uuidName).concat(ext));
                                return [4 /*yield*/, (0, storage_1.uploadBytes)(baseStorageRef, compressedFile, { contentType: compressedFile.type })];
                            case 2:
                                uploadTask = _a.sent();
                                return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask.ref)];
                            case 3:
                                url = _a.sent();
                                result = { fileName: uuidName, url: url, caption: '', thumbnailUrl: '' };
                                return [2 /*return*/, result];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); };
                announcementID = (0, uuid_1.v4)();
                documentCreationPromises = branches.map(function (branch) { return __awaiter(void 0, void 0, void 0, function () {
                    var senderIsInReceivingBranch, docRef, imageUploaded;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                senderIsInReceivingBranch = (_a = branch.users) === null || _a === void 0 ? void 0 : _a.includes(uid);
                                return [4 /*yield*/, (0, firestore_1.addDoc)(baseAnnouncementColRef, {
                                        announcementID: announcementID,
                                        acknowledged: senderIsInReceivingBranch
                                            ? [
                                                {
                                                    time: firestore_1.Timestamp.fromDate(new Date()),
                                                    uid: uid,
                                                },
                                            ]
                                            : [],
                                        branchID: branch.teamId,
                                        companyID: companyID,
                                        message: message,
                                        pin: pin,
                                        isScheduled: isScheduled,
                                        broadcastDate: broadcastDate ? firestore_1.Timestamp.fromDate((0, moment_1.default)(broadcastDate).toDate()) : null,
                                        createdAt: firestore_1.Timestamp.now(),
                                        createdBy: uid,
                                        createdByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                                        updatedAt: firestore_1.Timestamp.now(),
                                        updatedBy: uid,
                                        updatedByDisplayName: displayName !== null && displayName !== void 0 ? displayName : '',
                                    })];
                            case 1:
                                docRef = _b.sent();
                                if (!images) return [3 /*break*/, 4];
                                return [4 /*yield*/, Promise.all(images.map(function (img) { var _a; return uploadMedia((_a = img.file) !== null && _a !== void 0 ? _a : null, docRef.id); }))];
                            case 2:
                                imageUploaded = _b.sent();
                                return [4 /*yield*/, (0, firestore_1.updateDoc)(docRef, { images: imageUploaded.map(function (img) { return img === null || img === void 0 ? void 0 : img.url; }) })];
                            case 3:
                                _b.sent();
                                _b.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [4 /*yield*/, Promise.allSettled(documentCreationPromises)];
            case 3:
                _c.sent();
                return [2 /*return*/];
        }
    });
}); });
// Selectors
var selectAllMOTDs = function (state) {
    return state.announcement.announcements;
};
exports.selectAllMOTDs = selectAllMOTDs;
var selectAllTeam = function (state) { return state.team.teams; };
exports.selectAllTeam = selectAllTeam;
var selectAllMember = function (state) { return state.member.members; };
exports.selectAllMember = selectAllMember;
exports.selectAllActiveMOTDsForToday = (0, toolkit_1.createSelector)([exports.selectAllMOTDs], function (motds) {
    return motds.filter(function (_a) {
        var createdAt = _a.createdAt, pin = _a.pin, isScheduled = _a.isScheduled, broadcastDate = _a.broadcastDate;
        var messageBroadcastDate = isScheduled ? broadcastDate : createdAt;
        var isPinned = isScheduled ? pin && (0, moment_1.default)(messageBroadcastDate).isSameOrAfter((0, moment_1.default)(), 'd') : pin;
        return (0, moment_1.default)(messageBroadcastDate).isSame((0, moment_1.default)(), 'd') || isPinned;
    });
});
exports.selectAnnouncements = (0, toolkit_1.createSelector)([exports.selectAllMOTDs, exports.selectAllTeam, exports.selectAllMember], function (announcements, teams, members) {
    var findUsersAndBranchByBranchID = function (branchID) {
        var branch = teams.find(function (_a) {
            var teamId = _a.teamId;
            return teamId === branchID;
        });
        var usersBelongToBranch = members.filter(function (_a) {
            var memberId = _a.memberId;
            return branch === null || branch === void 0 ? void 0 : branch.users.includes(memberId);
        }) || [];
        return {
            usersBelongToBranch: usersBelongToBranch,
            branch: branch,
        };
    };
    var findUsersByAccknowledgeCollection = function (acknowledged) {
        return (acknowledged || []).map(function (_a) {
            var uid = _a.uid;
            var account = members.find(function (_a) {
                var memberId = _a.memberId;
                return memberId === uid;
            });
            if (account) {
                return account.displayName || '';
            }
            return '';
        });
    };
    var today = (0, moment_1.default)();
    var remappedAnnouncement = __spreadArray([], announcements, true).sort(function (currentElement, nextElement) { return (nextElement.pin ? 1 : -1); })
        .map(function (announcement) {
        var mappedBranchAndUser = findUsersAndBranchByBranchID(announcement.branchID);
        var broadcastDate = announcement.isScheduled ? announcement.broadcastDate : announcement.createdAt;
        return {
            id: announcement.id,
            announcementID: announcement.announcementID,
            date: (0, moment_1.default)(announcement.createdAt),
            message: announcement.message,
            branch: mappedBranchAndUser.branch,
            branchUsers: mappedBranchAndUser.usersBelongToBranch.map(function (_a) {
                var displayName = _a.displayName;
                return displayName || '';
            }),
            acknowledged: findUsersByAccknowledgeCollection(announcement.acknowledged),
            isArchived: today.isAfter((0, moment_1.default)(broadcastDate), 'd') && !announcement.pin,
            pin: announcement.pin,
            images: announcement.images,
            isScheduled: announcement.isScheduled,
            broadcastDate: announcement.broadcastDate,
            createdAt: announcement.createdAt,
            createdBy: announcement.createdBy,
            createdByDisplayName: announcement.createdByDisplayName,
            updatedAt: announcement.updatedAt,
            updatedBy: announcement.updatedBy,
            updatedByDisplayName: announcement.updatedByDisplayName,
        };
    })
        .filter(function (announcement) { return !!announcement.branch; })
        .sort(function (_motd, _nextMotd) {
        // Pin on top then sort by date in asc order
        if (_motd.pin) {
            return -1;
        }
        if (_nextMotd.pin) {
            return 1;
        }
        return _nextMotd.date.unix() - _motd.date.unix();
    });
    return {
        announcements: remappedAnnouncement,
    };
});
// Actions
exports.setAnnouncements = announcementSlice.actions.setAnnouncements;
exports.default = announcementSlice.reducer;
